import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Header from "../components/Header";
import Lookup from "../components/Lookup";

export default function Home() {
  const [trending, setTrending] = useState([]);
  const [selectedInstance, setSelectedInstance] = useState(null);
  const [uris, setUris] = useState([]);

  const apiUrl =
    "https://api.invidious.io/instances.json?pretty=1&sort_by=health,api,users";

  const fetchInstances = async () => {
    try {
      const response = await fetch(apiUrl);
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      setUris(data.map(([_, instance]) => instance.uri));
      setSelectedInstance(data[0][1].uri); // Set the first URI as default
    } catch (error) {
      console.error(error.message);
    }
  };

  useEffect(() => {
    fetchInstances();
  }, []);

  useEffect(() => {
    if (selectedInstance) {
      fetchData();
    }
  }, [selectedInstance]);

  const fetchData = async () => {
    try {
      const trend = `${selectedInstance}/api/v1/popular`;
      const response = await fetch(trend);
      if (!response.ok) {
        throw new Error("Failed to fetch data");
      }
      const data = await response.json();
      setTrending(data);
      // Set the document title to the video title
      document.title = "Mirai - Home";
    } catch (error) {
      console.error(error.message);
    }
  };

  return (
    <>
      <Header />
      <Lookup selectedInstance={selectedInstance} />
      <div className="flex justify-center ">
        <select
          className="p-2 border rounded mx-auto w-1/2"
          value={selectedInstance}
          onChange={(e) => setSelectedInstance(e.target.value)}
        >
          <option value="">Select Instance</option>
          {uris.map((uri, index) => (
            <option key={index} value={uri}>
              {uri}
            </option>
          ))}
        </select>
      </div>
      <div className="p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-4 xl:container mx-auto">
        {trending.map((trend, index) => (
          <div key={index} className="relative">
            <Link
              to={{
                pathname: `/player/${trend["videoId"]}`,
                search: `?instance=${selectedInstance}`,
              }}
            >
              <img
                className="w-full h-full object-cover object-center rounded-lg"
                src={`https://i.ytimg.com/vi_webp/${trend["videoId"]}/mqdefault.webp`}
                alt={trend["title"]}
              />
            </Link>
            <div className="absolute bottom-0 left-0 bg-black bg-opacity-50 w-full text-white p-2">
              <p className="text-sm">{trend["title"]}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  );
}
